export const modalNames = {
  SUPPORT: "SUPPORT",
  WORKER_INFO: "WORKER_INFO",
};
